import { ReactElement } from 'react'
import NewProposalPercent from './ProposalPercent'
import SalesChart from './ConversionChart'

import { NewAnalyticsTableWeb } from './NewAnalyticsTable'
import { NewAnalyticsCurrentWeb } from './NewAnalyticsCurrentMonth'

import { useNavigate } from 'react-router-dom'

import { useAuth, useGuard } from '../../hooks/auth'

import { LOCAL_EXECUTION } from '../../utils/featureFlag'

import {
  FContainer,
  Container,
  HeaderContainer,
  HeaderTitleText,
  MainContainer,
  TitleContainer,
  MainGrid,
  LeftPanel,
  RightPanel,
  BottomPanel,
} from './style'

export function NewAdvanceAnalytics(): ReactElement {
  const authContext = useAuth()
  const navigate = useNavigate()
  const { authHookWithOutEvent } = authContext

  // AUTH SECTION
  if (!LOCAL_EXECUTION) {
    authHookWithOutEvent(navigate)
  }

  useGuard(['ADVANCED'])

  // ---------------------------------------------

  return (
    <FContainer>
      <Container>
        <MainContainer>
          <HeaderContainer>
            <TitleContainer>
              <HeaderTitleText>{'Dashboard Nova Antecipação'}</HeaderTitleText>
            </TitleContainer>
          </HeaderContainer>
          <NewAnalyticsCurrentWeb />
          <br />
          <br />
          <MainGrid>
            <LeftPanel>
              <SalesChart label="" />
            </LeftPanel>
            <RightPanel>
              <NewProposalPercent title="Percentual de Taxas" />
            </RightPanel>
          </MainGrid>

          <BottomPanel>
            <NewAnalyticsTableWeb key={'web-table'} />
          </BottomPanel>
        </MainContainer>
      </Container>
    </FContainer>
  )
}
